import { AlgoliaModelMapper } from "@api/mappers/products.mapper";

import { ProductVisibilityTypes } from "@utils/enums";

import {
    AlgoliaRecommendHit,
    AlgoliaRecommendationsResponse,
} from "@services/algolia/types/search.types";

import { ProductAlgoliaModel } from "../../../../@types/service/product/algolia/product.algolia.model";

const hasHiddenVisibilityType = ({
    productVisibilityType,
}: AlgoliaRecommendHit<ProductAlgoliaModel>) =>
    [
        ProductVisibilityTypes.NotAvailable,
        ProductVisibilityTypes.TemporaryNotAvailable,
        ProductVisibilityTypes.OnlyAvailableInStore,
        ProductVisibilityTypes.Offline,
    ].every(
        visibilityTypeToHide => visibilityTypeToHide !== productVisibilityType,
    );

const removeDuplicateHits = (
    uniqueHits: Array<AlgoliaRecommendHit<ProductAlgoliaModel>>,
    hit: AlgoliaRecommendHit<ProductAlgoliaModel>,
) =>
    uniqueHits.map(({ objectID }) => objectID).includes(hit.objectID)
        ? uniqueHits
        : [...uniqueHits, hit];

const getProductsFromResponse =
    (limit?: number, excludedObjectIds: Array<string> = []) =>
    (response: AlgoliaRecommendationsResponse<ProductAlgoliaModel>) =>
        response.results
            .flatMap(
                ({ hits }) =>
                    hits as AlgoliaRecommendHit<ProductAlgoliaModel>[],
            )
            .filter(hasHiddenVisibilityType)
            .filter(hit => !excludedObjectIds.includes(hit.objectID))
            .reduce(removeDuplicateHits, [])
            .sort((a, b) => (b._score ?? 0) - (a._score ?? 0))
            .slice(0, limit)
            .map(AlgoliaModelMapper);

export { getProductsFromResponse };
